module.exports = __webpack_public_path__ + "media/images/emblems/Marbach_Wappen_2-915bc6691d5e4af3687d3ed70336b401.png";